export const WELL_SEISMIC_TYPE_LIST = 'WELL_SEISMIC_TYPE_LIST';
export const WELL_SEISMIC_TYPE_LIST_SUCCESS = 'WELL_SEISMIC_TYPE_LIST_SUCCESS';
export const WELL_SEISMIC_TYPE_LIST_ERROR = 'WELL_SEISMIC_TYPE_LIST_ERROR';

export const WELL_SEISMIC_TYPE_UPDATE_DATA = 'WELL_SEISMIC_TYPE_UPDATE_DATA';